import { useInterfaceText } from "./InterfaceText";
import React, { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

/** Friendly PWA install banner — mobile only, shown from the 2nd visit. */
export default function InstallBanner() {
  const __bcUi = useInterfaceText();

  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const mobile = /iphone|ipad|ipod|android/.test(ua);
    setIsIOS(/iphone|ipad|ipod/.test(ua));
    if (!mobile) return;
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return;
    if (localStorage.getItem('bc_install_banner_dismissed')) return;
    if (!sessionStorage.getItem('bc_visit_counted')) {
      sessionStorage.setItem('bc_visit_counted', '1');
      const visits = Number(localStorage.getItem('bc_visit_count') || 0) + 1;
      localStorage.setItem('bc_visit_count', String(visits));
    }
    if (Number(localStorage.getItem('bc_visit_count') || 0) >= 2) setVisible(true);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    localStorage.setItem('bc_install_banner_dismissed', '1');
    setVisible(false);
  };

  const install = async () => {
    const p = window.__pwaInstallPrompt;
    if (p) {
      p.prompt();
      const r = await p.userChoice;
      if (r.outcome === 'accepted') setVisible(false);
      window.__pwaInstallPrompt = null;
    } else {
      window.location.href = '/instalar';
    }
  };

  return (
    <div className="fixed bottom-20 left-3 right-3 z-[60] lg:hidden" data-testid="install-banner">
      <div className="flex items-center gap-3 bg-white border border-[#BFDBFE] rounded-2xl shadow-xl p-3">
        <div className="w-11 h-11 rounded-xl bg-[#EFF6FF] p-1 overflow-hidden shrink-0">
          <img src="/mascot.png" alt="Briefy" className="w-full h-full object-contain" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-extrabold text-[#0B1533] leading-tight">
            {t('installBanner.title', 'Instala BRIEFCASE en tu celular')}
          </p>
          <p className="text-xs text-[#64748B] leading-snug">
            {t('installBanner.subtitle', 'Acceso directo, más rápido y a pantalla completa')}
          </p>
        </div>
        <button
          onClick={install}
          data-testid="install-banner-btn"
          className="shrink-0 inline-flex items-center gap-1.5 px-3 py-2 rounded-xl bg-[#2563EB] hover:bg-[#1D4ED8] text-white text-xs font-bold transition-colors"
        >
          <Download className="w-3.5 h-3.5" />
          {isIOS && !window.__pwaInstallPrompt ? t('installBanner.how', 'Ver cómo') : t('installBanner.install', 'Instalar')}
        </button>
        <button onClick={dismiss} data-testid="install-banner-close" className="shrink-0 p-1 text-[#94A3B8] hover:text-[#475569]" aria-label={__bcUi("Cerrar")}>
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
